import { Button, Cell, Grid, Heading, Text, VFlow } from 'bold-ui'
import { PageContent } from 'components/layout/PageContent'
import { BUSCA_ATIVA_VACINACAO_PATH } from 'components/layout/SideMenu/SideMenuItems'
import image from 'images/busca-ativa/mudanca-busca-ativa.svg'
import React from 'react'
import { useHistory } from 'react-router'

export default function BuscaAtivaVacinacaoRedirectView() {
  const history = useHistory()

  return (
    <PageContent>
      <Grid style={{ paddingTop: '10rem' }} alignItems='center' justifyContent='center'>
        <Cell size={4}>
          <VFlow>
            <Heading level={1}>A busca ativa de vacinação mudou de lugar!</Heading>
            <Text>Agora você pode acessar a busca ativa de vacinação no módulo de acompanhamentos.</Text>
            <Button kind='primary' onClick={() => history.push(BUSCA_ATIVA_VACINACAO_PATH)}>
              <Text color='inherit'>Acessar acompanhamento</Text>
            </Button>
          </VFlow>
        </Cell>
        <Cell size={6}>
          <img
            src={image}
            alt='Um caminhão de mudança carregando caixas de vacinas, indicando que a busca ativa de vacinação está mudando de lugar'
          />
        </Cell>
      </Grid>
    </PageContent>
  )
}
